import { SetPersonalRecordType } from 'hevy-shared';
import { t } from 'translations/t';

export const prTitleForPRType = (prType: SetPersonalRecordType) => {
  switch (prType) {
    case 'best_1rm':
      return t('web.prTitles.best1rm');
    case 'best_distance':
      return t('web.prTitles.bestDistance');
    case 'best_duration':
      return t('web.prTitles.bestDuration');
    case 'best_volume':
      return t('web.prTitles.bestVolume');
    case 'best_weight':
      return t('web.prTitles.bestWeight');
    case 'best_reps':
      return t('web.prTitles.bestReps');
  }
};
